export default __webpack_public_path__ + "static/media/dialofdestiny001.26ac7a72.jpeg";